module.exports = __webpack_public_path__ + "static/media/ecg.372fd363.gif";